import React, { createContext, useContext, useState, ReactNode } from "react";
import Cookies from "js-cookie";

interface AuthContextType {
  isAuthenticated: boolean;
  authData: any;
  login: (data: any) => void;
  logout: () => void;
}

interface AuthProviderProps {
  children: ReactNode;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const [authData, setAuthData] = useState<any>(() => {
    const data = localStorage.getItem("authData");
    return data ? JSON.parse(data) : null;
  });

  const [isAuthenticated, setIsAuthenticated] = useState(
    !!(Cookies.get("token") || localStorage.getItem("token")),
  );

  const login = (data: any) => {
    localStorage.setItem("token", data.token);
    localStorage.setItem("authData", JSON.stringify(data));

    Cookies.set("token", data.token, {
      expires: 1,
      sameSite: "strict",
    });

    setAuthData(data);
    setIsAuthenticated(true);
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("authData");
    localStorage.removeItem("userPersonalData");

    Cookies.remove("token");

    setAuthData(null);
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        authData,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth must be used inside AuthProvider");
  }

  return context;
};
